import React from "react";
import { useAuth } from "../../Context/authContext";
import MentorIdeaDetail from "./MentorIdeaDetail";
import StudentIdeaDetail from "./StudentIdeaDetail";
import MentorEngagementDetail from "../EngagementDetail/MentorEngagementDetail";

const IdeaDetail = () => {
  const { user } = useAuth();

  if (user?.role === 'mentor') {
    return <MentorIdeaDetail />;
  }

  if (user?.role === 'admin') {
    return <MentorEngagementDetail isReadOnly />;
  }

  return <MentorEngagementDetail reviewReadOnly />;
};

export default IdeaDetail;
